module.exports = __webpack_public_path__ + "media/alaska/black-5e1ce12b.jpg";